module.exports = __webpack_public_path__ + "static/media/this_prev.3309ba55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/img/current/this_prev.png
// module id = 100
// module chunks = 0